import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {
    Modal,
    Form,
    Input,
    InputNumber,
    Button,
    Space,
    Row,
    Col,
    DatePicker,
    Select,
    Table,
    Typography,
    message, Flex, Tag, Upload
} from "antd";
import CardSelectModal from "./CardSelectModal.jsx";
import SelectedCardList from "./SelectedCardList.jsx";
import TableModal from "../../../../components/TableModalBM";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";
import "../../../../custombm.css";
import {columnsCardContracts, dataCardContractsFilter, dataCardContractsTab} from "../CardRegistryData";
import {mapApiToForm} from "./api/mapApiToForm";
import MoneyInput from "../../../../components/MoneyInput";
import {EyeOutlined, FileExcelOutlined, UploadOutlined} from "@ant-design/icons";
import queryApi from "api/queryApi";

const RegistryFormModal = ({ open, onCancel, onSave, mode = 'create' }) => {

    const { t } = useTranslation();
    const [messageApi, contextHolder] = message.useMessage();
    const [isSubmitting,setIsSubmitting] = useState(false)

    const [fileName, setFileName] = useState('');
    const [form] = Form.useForm();
    const [cards, setCards] = useState([]);
    const [cardModalOpen, setCardModalOpen] = useState(false);
    const [docDate  , setDocDate] = useState("");
    const [accCode, setAccCode] = useState("");
    const [chooseDisabled, setChooseDisabled] = useState(false);
    const prevModeRef = useRef(mode);

    const isView = mode === "view";

    useEffect(() => {

        if (prevModeRef.current === 'view' && mode === 'create') {
            form.resetFields();

            setCards([]);
        }
        prevModeRef.current = mode;
        form.setFieldValue('expense', '14111100')
        /*if (initialData === null || mode === 'create') return;

        const mapped = mapApiToForm(initialData);

        form.setFieldsValue(mapped.formValues);
        setCards(mapped.cards);*/

    }, [mode]);

    const handleAddCards = useCallback((selectedCards) => {
        setCards((prev) => {

            return selectedCards.map((card, index) => {
                const existing = prev.find((p)=> p.mbat_id === card.mbat_id)
                return {
                    ...card,
                    amount: existing?.amount || 0,
                    orderNum: index + 1
                }
            })

        })

        setCardModalOpen(false);
    },[]);

    const totalAmount = useMemo(() => {
        //if (mode === 'view') return initialData.registerAmount;
        const roundSum = cards.reduce((sum, card) => {
            const amount = Number(card.amount || 0)
            return sum + Math.round(amount * 100)
        },0);
        return roundSum/100
    },[cards])

    const handleAmountChange = useCallback((cardId, value) => {
        setCards((prev) =>
            prev.map((card) =>
                card.mbat_id === cardId ? { ...card, amount: value } : card
            )
        );
    },[]);

    const handleDeleteCard = useCallback((mbat_id) => {
        setCards((prev) =>
            prev.filter((c) => c.mbat_id !== mbat_id)
                .map((c, index) => ({...c, orderNum: index+1}))
        )
    },[])

    const handleSave = async () => {
        form.validateFields()
            .then(async (values) => {
                setIsSubmitting(true);
                values.docYear  = Number.parseInt(values.period.format('YYYY'));
                values.docMonth = values.period.format('MM');
                values.docDate = values.docDate.format('DD.MM.YYYY');
                const currentDate = new dayjs();
                values.operDay = currentDate.format('DD.MM.YYYY');

                if (cards.length === 0) {
                    messageApi.open({
                        type: 'warning',
                        content: 'Карталар танланмаган',
                        duration: 2,
                    });
                    return;
                }
                const registerAmount = cards.reduce(
                    (sum, card) => sum + Number(card.amount || 0),
                    0
                );

                const balance = cards.map((rec) => ({
                        "employeeClientId": rec.client_uid,
                        "employeeContractId": rec.contract_id,
                        "cardNumber": rec.card_number,
                        "payPurpose": values.purpose,
                        "mode": values.mode,
                        "codeFilial": values.codeFilial,
                        "currency": values.currency,
                        "balanceAmount": rec.amount,
                        "embossedName": rec.embossed_name
                } ))

                delete values.period
                delete values.purpose



                const newRegistry = {
                    //id: Date.now(),
                    ...values,
                    registerAmount,
                    balance,
                };

                const respSave = await onSave(newRegistry);

                if (respSave) {
                    form.resetFields();
                    setCards([])
                    setChooseDisabled(false);
                }
            }).catch((errorInfo) => {
                console.log('errorInfo ...', errorInfo);
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 1000);
        })


    };

    const changeCardContract = (res) => {
        form.setFieldValue('codeFilial',res.code_filial)
        form.setFieldValue('contractId',res.contract_id)
        form.setFieldValue('currency',res.currency)
        form.setFieldValue('bxmCode',res.bxm_code)
        form.setFieldValue('clientId',res.client_id)
        form.setFieldValue('filename',res.file_name)
        form.setFieldValue('account',res.account)
        form.setFieldValue('accountBalance',res?.accountBalance || 0)
    }

    function changeDateFormat(date, dateString){
        setDocDate(dateString)
    }

    const handleCardModalOpen = () => {
        if (chooseDisabled) return;
        console.log(form.getFieldValue("contractId"),'qqq')
        const contractIdValue = form.getFieldValue("contractId")
        if (contractIdValue === null || contractIdValue === undefined || contractIdValue === '') {
            messageApi.open({
                type: 'warning',
                content: t('contract')+t('choose'),
                duration: 2
            })
        }
        else setCardModalOpen(true)
    }

    const handleUpload = async (file) => {
        try {
            const formData = new FormData();
            formData.append("file", file);
            const contractIdValue = form.getFieldValue("contractId")
            const response = await queryApi.post(`/bank_card/salary_registry/loadFromExcel?contract_id=${contractIdValue}`,
                formData,
                {
                    headers: {
                        // Перебиваем json-умолчание queryApi: иначе axios свернёт
                        // FormData в JSON и multipart-загрузка сломается.
                        'Content-Type': 'multipart/form-data',
                        request_uri: "1.0.0/search-jur-client?clientId=101343&cardCode=1",
                    },
                }
            );

            const {data} = await response;

            const mapped = mapApiToForm(data);
            form.setFieldsValue(mapped.formValues);
            setCards(mapped.cards);
            setChooseDisabled(true);
            //setApiData(data);

            messageApi.open({
                type: 'success',
                content: t('fileUploadSuccess'),
                duration: 3,
            });

        } catch (err) {
            messageApi.open({
                type: 'error',
                content: t('fileUploadError') + ' ' + err?.response?.data?.message,
                duration: 4,
            });
        }
    }

    const uploadProps = {
        name: "file",
        beforeUpload: (file) => {
            setFileName(file.name);
            handleUpload(file).then(r => console.log(r,'rrr'));
            return false;
        },
        showUploadList: false,
        accept: ".xls,.xlsx"
    };

    return (
        <>
            {contextHolder}
            <Modal
                open={open}
                onCancel={()=> {
                    form.resetFields();
                    setCards([]);
                    setFileName('');
                    setChooseDisabled(false);
                    onCancel()
                }}
                onOk={handleSave}
                okText={t("save")}
                cancelText={t("exit")}
                disabled={isSubmitting}
                title={t('createRegister')}
                width="70%"

            >
                <Form form={form} initialValues={{"period": dayjs()}}>
                    {/*<div style={{display:"flex", flexDirection:"row", justifyContent:"left",alignItems:"center"}}>*/}

                    <Form.Item name="cardCode"      label="cardCode"        style={{display: 'none'}} initialValue={1}><Input type="text"/></Form.Item>
                    <Form.Item name="mode"          label="mode"            style={{display: 'none'}} initialValue={"A"}><Input type="text"/></Form.Item>
                    <Form.Item name="balanceTypeId" label="balanceTypeId"   style={{display: 'none'}} initialValue={1}><Input type="text"/></Form.Item>
                    <Space.Compact block direction="vertical">

                        <Row gutter={[8, 8]} style={{marginRight: '0', marginLeft: '0'}}>

                            {/* <Col span={2}>
                                <Button
                                    onClick={handleCreate}
                                    type="primary"
                                >
                                    Сақлаш
                                </Button>
                            </Col>*/}

                            <Col span={22}>

                                <Space>

                                    {/*<Form.Item name="idSmeta" label="idSmeta" initialValue="0" hidden={true} rules={[{required: true, message:'id киритинг!'}]}>
                                        <Input style={{width:'50px'}}/>
                                    </Form.Item>*/}

                                    <Form.Item name="docNumber" label={t('docNumb')}
                                               rules={[{required: true, message: t('docNumb')+t('choose')}]}>
                                        <Input type="text" style={{width: '90px'}} readOnly={isView}/>
                                    </Form.Item>

                                    <Form.Item name="docDate" label={t('docDate')}
                                               rules={[{required: true, message: t('docDate')+t('choose')}]}>
                                        <DatePicker label="Хужжат санаси" format='DD.MM.YYYY' disabled={isView}
                                                    onChange={changeDateFormat}/>
                                    </Form.Item>

                                    <Space>

                                        <Form.Item name="period" label={t('period')}
                                                   rules={[{required: true, message: t('period')+t('choose')}]}
                                                   style={{width: '200px'}}>
                                            <DatePicker format={'YYYY/MM'} picker="month" disabled={isView}/>
                                            {/*<Select placeholder="Период танланг">
                                            {periodArr &&
                                                periodArr.map((elem) => {
                                                    return (
                                                        <Option key={elem}>{elem}</Option>
                                                    )
                                                })
                                            }
                                        </Select>*/}
                                        </Form.Item>

                                        <Form.Item name="expense" label={t('expCode')}
                                                   rules={[{required: true, message: t('expCode')+t('choose')}]}>
                                            <Input type="text" readOnly={true} style={{width: '90px'}}/>
                                        </Form.Item>

                                        <Form.Item name="account" label={t('bankAcc')}
                                                   rules={[{required: true, message: t('bankAcc')+t('choose')}]}>
                                            <Input type="text" readOnly={true} style={{width: '180px'}}/>
                                        </Form.Item>

                                    </Space>

                                    {/*<Space.Compact block>

                                        <Form.Item name="acc" label="Хисоб ракам"
                                                   rules={[{required: true, message: 'Хисоб ракамни танланг!'}]}>
                                            <Input maxLength="20" width="180px" value={accCode} onChange={setAccCode}
                                                   readOnly={true}/>
                                            <NumericInput style={{ width: 180, }} value={accCode} onChange={setAccCode}/>
                                        </Form.Item>

                                        <Form.Item name="accId" label="accId" style={{display: 'none'}}>
                                            <Input type="text"/>
                                        </Form.Item>

                                        <Form.Item name="accName"
                                                   rules={[{required: false, message: 'Хисоб ракамни номи буш!'}]}
                                                   style={{width: "400px"}}>
                                            <Input readOnly={true}/>
                                        </Form.Item>

                                        <TableModal modalDataTab={dataSmetaAccTab(auth.empId)}
                                                    modalColumnTab={columnsAcc(t)}
                                                    modalFilterTab={dataSmetaAccFilter}
                                                    modalTitleTab="Хисоб ракамлар"
                                                    onSubmit={changeAccCode}
                                        />

                                    </Space.Compact>*/}

                                </Space>

                            </Col>

                        </Row>

                        <Row gutter={[8, 8]} style={{marginRight: '0', marginLeft: '0'}}>

                            <Col span={24} style={{marginBottom: 16, width:'100%', display:'flex',justifyContent: 'space-between'}}>


                                    {/*<Form.Item name="finyear" label="Йил" rules={[{ required: true, message:'Йилни танланг!'}]} >
                                        <DatePicker picker="year" defaultValue={dayjs()} format="YYYY"/>

                                    </Form.Item>*/}
                                    <>
                                        <Space.Compact>

                                            <Form.Item name="contractId" label={t('contract')}
                                                       rules={[{required: true, message: t('contract')+t('choose')}]}>
                                                <Input maxLength="20" width="180px" value={accCode} onChange={setAccCode}
                                                       readOnly={true}/>
                                                {/*<NumericInput style={{ width: 180, }} value={accCode} onChange={setAccCode}/>*/}
                                            </Form.Item>
                                            { !isView &&
                                            <TableModal modalDataTab={dataCardContractsTab}
                                                        modalColumnTab={columnsCardContracts(t)}
                                                        modalFilterTab={dataCardContractsFilter}
                                                        modalTitleTab="Карталар"
                                                        filterKey="CardContractsFilter"
                                                        onSubmit={changeCardContract}
                                            />
                                            }

                                        </Space.Compact>

                                        <Form.Item name="currency" label={t('currency')}    style={{display: 'none'}}><Input type="text" readOnly={true}/></Form.Item>
                                        <Form.Item name="bxmCode"  label={t('bxmCode')}     style={{display: 'none'}}><Input type="text" readOnly={true}/></Form.Item>
                                        <Form.Item name="clientId" label={t('clientId')}    style={{display: 'none'}}><Input type="text" readOnly={true}/></Form.Item>
                                        <Form.Item name="codeFilial" label={t('filial')}    style={{display: 'none'}}><Input type="text" readOnly={true}/></Form.Item>
                                        <Form.Item name="filename" label={t('fileName')}    style={{display: 'none'}}><Input type="text" readOnly={true}/></Form.Item>

                                        <Form.Item name="purpose" label={t('purpose')}
                                                   rules={[{required: true, message: t('purpose')+t('choose')}]}>
                                            <Input style={{width: '600px'}} readOnly={chooseDisabled}/>
                                        </Form.Item>
                                    </>

                                    <Form.Item name="accountBalance" label={t('accountBalance')}
                                               rules={[{required: true, message: t('accountBalance')+t('choose')}]}>
                                        <Input readOnly={true} className='bm-input-number-align-right-nop-fwb'/>
                                    </Form.Item>

                            </Col>

                        </Row>

                    </Space.Compact>

                </Form>

                <Space style={{marginBottom: 16, width:'100%', display:'flex',justifyContent: 'space-between'}}>

                    {!isView &&
                        <>
                        <Button type="default" disabled={chooseDisabled} onClick={() => handleCardModalOpen()}>
                            {t('chooseCard')}
                        </Button>
                        <div style={{display: "flex", alignItems: "center", gap: 12}}>
                            <Upload name="fileData" {...uploadProps} style={{display: 'flex', 'gap': '10'}}>
                                <Button icon={<UploadOutlined/>}>{t('fileUpload')}</Button>
                            </Upload>

                            {fileName && (
                                <Space.Compact>
                                    <Input placeholder="" style={{width: "300px"}} value={fileName}
                                           prefix={<FileExcelOutlined/>} readOnly={true}/>
                                    {/*<Button icon={<EyeOutlined/>} onClick={() => handleView()}>{t('view')}</Button>*/}
                                </Space.Compact>
                            )}
                        </div>
                        </>
                }
                {/*<div style={{marginTop: 16}}>
                            <b>Сумма по картам: {totalAmount}</b>
                        </div>*/}
                        <Space.Compact block>
                            {/*<Space.Addon>Сумма по картам:</Space.Addon>*/}
                            <Input value="Сумма по картам:" readOnly={true} style={{backgroundColor:'#87d068',color:'#fff', width:200}}></Input>
                            <MoneyInput value={totalAmount} readOnly={true} className='bm-input-number-align-right'/>
                            {/*<InputNumber
                                className="bm-input-number-align-right-nop-fwb"
                                style={{ width: "100%"}}
                                value={totalAmount}
                                step={null}
                                controls={false}
                                readOnly={true}
                                formatter={(value) =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                }
                                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                            />*/}

                        </Space.Compact>

                </Space>


                <SelectedCardList
                    cards={cards}
                    onAmountChange={handleAmountChange}
                    onDelete={handleDeleteCard}
                    disabled={chooseDisabled}
                />

            </Modal>

            { cardModalOpen && !isView &&
            <CardSelectModal
                open={cardModalOpen}
                onCancel={() => setCardModalOpen(false)}
                onSelect={handleAddCards}
                selectedCards={cards}
                contractId={form.getFieldValue("contractId")}
            />
            }
        </>
    );
};

export default RegistryFormModal;